module.exports = __webpack_public_path__ + "img/icon_1.c7f48477.png";